<template>
  <div>
    <!-- Desktop layout -->
    <v-row v-if="!$vuetify.breakpoint.xsOnly" align="center" class="text-center py-3">
      <v-col cols="1">
        <v-checkbox :input-value="selected" @change="$emit('toggle-select', item)" hide-details class="mt-0 pt-0" color="primary" />
      </v-col>
      <v-col cols="4" class="text-left d-flex align-center">
        <v-img :src="getImageUrl(item.productImage)" max-width="80" max-height="80" contain class="mr-4 rounded" style="border:1px solid #eee;" />
        <div>
          <div class="subtitle-2">{{ item.productName }}</div>
          <div v-if="item.variantId" class="caption grey--text">{{ getVariantText(item) }}</div>
        </div>
      </v-col>
      <v-col cols="2">฿ {{ formatPrice(item.price) }}</v-col>
      <v-col cols="2">
        <div class="d-flex align-center justify-center quantity-control">
          <v-btn x-small text class="quantity-btn" @click="$emit('update-qty', item, -1)" :disabled="item.quantity <= 1">-</v-btn>
          <input type="number" v-model.number="localQty" class="mx-2 quantity-input"
            @blur="clampAndEmit" @keyup.enter="clampAndEmit" min="1" :max="itemStock" />
          <v-btn x-small text class="quantity-btn" @click="$emit('update-qty', item, 1)" :disabled="item.quantity >= itemStock">+</v-btn>
        </div>
      </v-col>
      <v-col cols="2" class="font-weight-bold">฿ {{ formatPrice(item.subtotal) }}</v-col>
      <v-col cols="1">
        <span class="red--text caption cursor-pointer" @click="$emit('remove', item)">ลบ</span>
      </v-col>
    </v-row>

    <!-- Mobile layout -->
    <div v-else class="mobile-cart-item py-3">
      <div class="d-flex align-start">
        <v-checkbox :input-value="selected" @change="$emit('toggle-select', item)" hide-details class="mt-0 pt-0 mr-2 shrink-0" color="primary" />
        <v-img :src="getImageUrl(item.productImage)" width="72" height="72" contain class="rounded mr-3 shrink-0" style="border:1px solid #eee;" />
        <div class="grow min-width-0">
          <div class="subtitle-2 mb-1" style="line-height:1.3">{{ item.productName }}</div>
          <div v-if="item.variantId" class="caption grey--text mb-1">{{ getVariantText(item) }}</div>
          <div class="caption grey--text">ราคา: <span class="font-weight-medium black--text">฿ {{ formatPrice(item.price) }}</span></div>
        </div>
      </div>
      <div class="d-flex align-center justify-space-between mt-2 pl-10">
        <div class="d-flex align-center quantity-control">
          <v-btn x-small text class="quantity-btn" @click="$emit('update-qty', item, -1)" :disabled="item.quantity <= 1">-</v-btn>
          <input type="number" v-model.number="localQty" class="mx-2 quantity-input"
            @blur="clampAndEmit" @keyup.enter="clampAndEmit" min="1" :max="itemStock" />
          <v-btn x-small text class="quantity-btn" @click="$emit('update-qty', item, 1)" :disabled="item.quantity >= itemStock">+</v-btn>
        </div>
        <div class="font-weight-bold primary--text">฿ {{ formatPrice(item.subtotal) }}</div>
        <span class="red--text caption cursor-pointer" @click="$emit('remove', item)">ลบ</span>
      </div>
    </div>

    <v-divider v-if="!lastItem" />
  </div>
</template>

<script>
import { getImageUrl } from "@/utils/image";
export default {
  name: "CartItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    lastItem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localQty: this.item.quantity,
    };
  },
  computed: {
    itemStock() {
      return this.item.variant?.stock ?? this.item.product?.stock ?? Infinity;
    },
  },
  watch: {
    "item.quantity"(val) {
      this.localQty = val;
    },
  },
  methods: {
    clampAndEmit() {
      const val = parseInt(this.localQty) || 1;
      const clamped = Math.min(Math.max(val, 1), this.itemStock);
      this.localQty = clamped;
      if (clamped !== this.item.quantity) {
        this.$emit("set-qty", this.item, clamped);
      }
    },
    getImageUrl,
    formatPrice(val) {
      return Number(val).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    getVariantText(item) {
      // First try to get from variant object (from backend)
      if (item.variant) {
        const parts = [];
        if (item.variant.color) parts.push(item.variant.color);
        if (item.variant.size) parts.push(item.variant.size);
        if (parts.length > 0) return parts.join(" ");
      }

      // Fallback to options object
      if (item.options && typeof item.options === "object") {
        return Object.values(item.options).join(", ");
      }

      return "";
    },
  },
};
</script>

<style scoped>
.quantity-control {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  display: inline-flex;
  padding: 2px;
}

.quantity-btn {
  min-width: 28px !important;
  height: 28px !important;
}

.quantity-input {
  width: 40px;
  min-width: 30px;
  text-align: center;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  -moz-appearance: textfield;
}
.quantity-input::-webkit-inner-spin-button,
.quantity-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

.cursor-pointer {
  cursor: pointer;
  text-decoration: underline;
}
</style>
